import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay, EffectFade, Navigation } from "swiper/modules";
import { Quote, Star } from "lucide-react";
import "swiper/css";
import "swiper/css/pagination";
import { TESTIMONIALS } from "../../lib/constants";

const Testimonials = () => {
  return (
    <section className="py-20 md:py-28 bg-gradient-to-b from-megha-bg to-white relative overflow-hidden" data-testid="section-testimonials">
      <div className="absolute -top-32 left-1/2 -translate-x-1/2 w-[700px] h-[700px] rounded-full bg-megha-accent/5 blur-3xl pointer-events-none" />

      <div className="relative max-w-6xl mx-auto px-4 sm:px-6 lg:px-10">
        <div className="text-center max-w-3xl mx-auto">
          <div className="text-xs font-semibold tracking-[0.2em] uppercase text-megha-accent">Voices of MIETW</div>
          <h2 className="mt-2 font-heading font-extrabold text-3xl md:text-4xl lg:text-5xl tracking-tight text-megha-text">
            Stories from our students, alumni & parents.
          </h2>
        </div>

        <div className="mt-14">
          <Swiper
            modules={[Pagination, Autoplay]}
            spaceBetween={24}
            slidesPerView={1}
            breakpoints={{
              768: { slidesPerView: 2 },
              1024: { slidesPerView: 2 },
            }}
            pagination={{ clickable: true }}
            autoplay={{ delay: 4500, disableOnInteraction: false }}
            loop
            className="!pb-14"
            data-testid="testimonials-carousel"
          >
            {TESTIMONIALS.map((t, i) => (
              <SwiperSlide key={i}>
                <div className="glass rounded-3xl p-8 shadow-[0_18px_50px_rgba(11,59,140,0.08)] h-full flex flex-col">
                  <Quote className="w-9 h-9 text-megha-highlight" />
                  <div className="flex gap-0.5 mt-3">
                    {Array.from({ length: 5 }).map((_, k) => (
                      <Star key={k} className="w-4 h-4 fill-megha-highlight text-megha-highlight" />
                    ))}
                  </div>
                  <p className="mt-4 text-base md:text-lg text-megha-text leading-relaxed flex-1">
                    "{t.quote}"
                  </p>
                  <div className="mt-6 flex items-center gap-3">
                    <img
                      src={t.avatar}
                      alt={t.name}
                      className="w-12 h-12 rounded-full object-cover border-2 border-white shadow-md"
                    />
                    <div>
                      <div className="font-heading font-bold text-megha-text">{t.name}</div>
                      <div className="text-xs text-slate-500">{t.branch}</div>
                    </div>
                  </div>
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>

      <style>{`
        .swiper-pagination-bullet { background: #0B3B8C; opacity: 0.3; }
        .swiper-pagination-bullet-active { background: #0B3B8C; opacity: 1; width: 24px; border-radius: 4px; }
      `}</style>
    </section>
  );
};

export default Testimonials;
